import Http from 'axios'
import {API_URL, VERSION, VERSIONED_API_URL} from '../../config/config'
import {
    SET_CERTIFICATION_DATA,
    SET_VOUCHER_GENERATED,
    SET_FORWARD_PURPOSE,
    SET_TIPPANI_VERIFICATION_MODAL
} from "../mutation-type";
import {
    APPROVE_VISA_CERTIFICATION,
    CHECK_VISA_CERTIFICATION_PAYMENT_STATUS, GENERATE_VOUCHER,
    GET_VISA_CERTIFICATION, REJECT_VISA_CERTIFICATION,
    SAVE_VISA_CERTIFICATION_TIPPANI,
    VERIFY_CERTIFICATION,
    FORWARD_CERTIFICATION,
    VERIFY_APPROVE_TIPPANI_CERTIFICATION

} from "../action-type";

const initialState = {
    certificationDetail: {
        certification_data: [],
        traveller: [],
        visa: [],
        id: null,
    },
    type: null,
    tippaniContent: null,
    approveData: {},
    rejectData: {},
    tippaniVerificationModel: false,
    forwardPurpose: null,
};

const getters = {
    certificationDetail: state => state.certificationDetail,
    certificationTippani: state => state.tippaniContent,
    certificationApproveData: state => state.approveData,
    certificationRejectData: state => state.rejectData,
    certificationType: state => state.type
};

const actions = {
    [GET_VISA_CERTIFICATION]({commit, state}, id) {
        return new Promise(((resolve, reject) => {
            Http.get(`${API_URL}${VERSION}/certifications/${state.type}/${id}`).then((res) => {
                commit(SET_CERTIFICATION_DATA, res.data.data);
                resolve(true)
            })
        }));
    },

    [SAVE_VISA_CERTIFICATION_TIPPANI]({state, commit}, content) {
        return new Promise(((resolve, reject) => {
            Http.put(`${API_URL}${VERSION}/certifications/tippani/${state.type}/` + state.certificationDetail.submission_no, {content}).then((res) => {
                resolve(res)
            }).catch((err) => {
                reject(err)
            })
        }));
    },

    [CHECK_VISA_CERTIFICATION_PAYMENT_STATUS]({state, dispatch}, tippani_content) {
        return new Promise(((resolve, reject) => {
            Http.put(`${API_URL}${VERSION}/certifications/payment-status/${state.type}/` + state.certificationDetail.submission_no).then((res) => {
                dispatch(GET_VISA_CERTIFICATION, state.certificationDetail.id);
                resolve(res)
            }).catch((err) => {
                reject(err)
            })
        }));
    },

    [APPROVE_VISA_CERTIFICATION]({state, dispatch}, tippani_content) {
        let formData = new FormData();
        let files = state.approveData.files;
        if(files && files.length) {
            for (let i = 0; i < files.length; i++) {
                formData.append(`files[${i}]`, files[i]);
            }
        }
        formData.set('remarks', state.approveData.remarks);
        return new Promise(((resolve, reject) => {
            Http.post(`${API_URL}${VERSION}/certifications/approve/${state.type}/` + state.certificationDetail.submission_no, formData).then((res) => {
                dispatch(GET_VISA_CERTIFICATION, state.certificationDetail.id);
                resolve(res)
            }).catch((err) => {
                reject(err)
            })
        }));
    },

    [REJECT_VISA_CERTIFICATION]({state, dispatch}, tippani_content) {
        let formData = new FormData();
        let files = state.rejectData.files;
        if (files && files.length) {
            for (let i = 0; i < files.length; i++) {
                formData.append(`files[${i}]`, files[i]);
            }
        }
        formData.set('remarks', state.rejectData.remarks);
        return new Promise(((resolve, reject) => {
            Http.post(`${API_URL}${VERSION}/certifications/reject/${state.type}/` + state.certificationDetail.submission_no, formData).then((res) => {
                dispatch(GET_VISA_CERTIFICATION, state.certificationDetail.id);
                resolve(res)
            }).catch((err) => {
                reject(err)
            })
        }));
    },

    async [GENERATE_VOUCHER]({state, commit}) {
        try {
            const response = await Http.post(`${VERSIONED_API_URL}/generate-track-voucher/` + state.certificationDetail.submission_no);
            commit(SET_VOUCHER_GENERATED, response.data.data);
            return response.data;
        } catch (e) {
            throw  e;
        }

    },

    [VERIFY_CERTIFICATION]({state,dispatch}){
        return new Promise(((resolve, reject) => {
            Http.post(`${API_URL}${VERSION}/certifications/verify/${state.type}/` + state.certificationDetail.submission_no)
                .then((res) => {
                    dispatch(GET_VISA_CERTIFICATION, state.certificationDetail.id);
                    resolve(res)
                })
                .catch((err) => {
                    reject(err)
                })
        }));
    },

    [FORWARD_CERTIFICATION]({commit, state}, formData) {
        return new Promise(((resolve, reject) => {
            Http.post(`${API_URL}${VERSION}/certifications/${state.type}/${state.certificationDetail.submission_no}/forward-user`, formData)
                .then((res) => {
                    commit(SET_CERTIFICATION_DATA, res.data.data);
                    resolve(true);
                })
                .catch(error => {
                    reject(error);
                });
        }));
    },

    [VERIFY_APPROVE_TIPPANI_CERTIFICATION]({commit, state}, payload) {
        return new Promise(((resolve, reject) => {
            Http.post(`${API_URL}${VERSION}/certifications/verify-approve-tippani/${state.type}/${state.certificationDetail.submission_no}`, payload)
                .then((res) => {
                    // commit(SET_CERTIFICATION_DATA, res.data.data);
                    resolve(res);
                })
                .catch(error => {
                    reject(error);
                });
        }));
    },
};

const mutations = {
    SET_CERTIFICATION_DATA(state, items) {
        state.certificationDetail = items
    },
    SET_CERTIFICATION_PRINT_CONTENT(state, items) {
        state.tippaniContent = items
    },
    SET_CERTIFICATION_TYPE(state, type) {
        state.type = type.charAt(0).toUpperCase() + type.substring(1);
    },
    SET_VOUCHER_GENERATED(state, data) {
        state.certificationDetail.voucher_number = data.voucher_number;
        state.certificationDetail.voucher_generated = true;
        state.certificationDetail.extra.malanika_active = data.malanika_active;
    },
    SET_TIPPANI_VERIFICATION_MODAL(state, status) {
        state.tippaniVerificationModel = status
    },
    SET_FORWARD_PURPOSE(state, item) {
        state.forwardPurpose = item
    },

};

export default {
    state: initialState,
    getters,
    actions,
    mutations
}
